// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const versionInfo = {
    "version": "1.0.0",
    "hash": "65d5a183",
    "commitDate": "1793826143"
};
/* tslint:enable */
